import { Sanitizes } from "helpers";

/**
 * function to check if the given value is an object
 * @param {any} value object to be tested
 * @return {boolean} true if the value is an object but not an array
 */

export const isObject = (value: any): boolean => !!value && Object.prototype.toString.call(value) === "[object Object]";

/**
 * function to check if the given value is a number
 * @param {any} value number to be tested
 * @return {boolean} true if the value is a number
 */

export const isNumber = (value?: string | number): boolean => {
  return ((value != null) &&
    (value !== '') &&
    !isNaN(Number(value.toString())));
}

/**
 * function to calculate the days between two dates
 * @param {string | Date} a the date to be compared
 * @param {string | Date} b the date to be compared
 * @return {number} number of the days
 */

export const inBetween = (a: string | Date, b: string | Date): number => {
  const inBetween = new Date(b).getTime() - new Date(a).getTime();
  return Math.round(inBetween / (1000 * 60 * 60 * 24));
}

/**
 * function to compare two given dates
 * @param {string | Date} a the date to be compared
 * @param {string | Date} b the date to be compared
 * @return {boolean} if the dates are the same
 */

export const isDateEquals = (a: string | Date, b: string | Date): boolean => {
  return Sanitizes.clearTime(a).getTime() === Sanitizes.clearTime(b).getTime();
}

/**
 * function to check if the assigned date is within the given range
 * @param {date} value date to be tested
 * @param {date} min min date
 * @param {date} max max date
 * @return {boolean} true if the date is within the range
 */

export const inRange = (value: Date, min?: Date, max?: Date): boolean => {
  if (!value) return false;
  return min && max
    ? (value > min || isDateEquals(value, min)) && (value < max || isDateEquals(value, max))
    : min && !max
      ? value > min || isDateEquals(value, min)
      : !min && max
        ? value < max || isDateEquals(value, max)
        : true;
};

/**
 * Function to check if an object is not empty (i.e., it has at least one own property).
 * 
 * @param {object} obj - The object to be tested.
 * @return {boolean} - Returns true if the object has at least one own property, false otherwise.
 */

export const isNotEmpty = (obj: object): boolean => {
  return Object.keys(obj).length > 0;
}

/**
 * Function to check if a given string value is a valid BSON ObjectId.
 *
 * A BSON ObjectId is a 24-character string consisting of hexadecimal digits.
 *
 * @param {string} value - The string to be tested.
 * @return {boolean} - Returns true if the string is a valid BSON ObjectId, false otherwise.
 */

export const isBSON = (value: string): boolean => {
  return value?.length === 24 && /^[0-9a-fA-F]{24}$/.test(value);
}